export type FeatureFlag = "newLogin" | "announcements";

type Environment = "local" | "dev" | "qa";

const STORAGE_PREFIX = "__intiza_ff_";

/**
 * Ambientes donde cada flag puede estar activo. Es una allowlist: un build que
 * no declara REACT_APP_ENVIRONMENT (prod) o declara uno que no está acá
 * (staging) nunca activa el flag, ni siquiera con el override de localStorage.
 */
const FLAG_ENVIRONMENTS: Record<FeatureFlag, Environment[]> = {
  newLogin: ["local", "dev", "qa"],
  // TODO(GDC-5174): quitar el flag cuando estén los endpoints de comunicados en backend.
  // Mientras tanto la campanita y el popup solo existen en local/dev, con datos de prueba.
  announcements: ["local", "dev"]
};

// CRA solo inlinea process.env.* cuando se accede de forma literal
const getCurrentEnvironment = (): string | undefined =>
  process.env.REACT_APP_ENVIRONMENT ??
  (process.env.NODE_ENV === "development" ? "local" : undefined);

/**
 * Un flag está prendido en los ambientes de su allowlist. Dentro de esos
 * ambientes, localStorage "__intiza_ff_<flag>" = "0" lo apaga en ese navegador.
 */
export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  const environment = getCurrentEnvironment();
  if (!FLAG_ENVIRONMENTS[flag].some((allowed) => allowed === environment)) {
    return false;
  }

  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${flag}`) !== "0";
  } catch {
    // localStorage bloqueado: queda el valor del ambiente
    return true;
  }
};
